import { LogErrors } from './../LogErrors'


//Agregar multiidioma en los mensajes

let listeners = [] // Para poder removerlos luego


// /**
//  * Función para detectar inyección SQL (ejemplo básico)
//  * @param {string} value 
//  * @returns 
//  */
// const ValidateSqlInjection = async (value) => {
//     try {    
//         const sqlInjectionKeywords = ['SELECT', 'INSERT', 'UPDATE', 'DELETE'] //';', '--', 'DROP'
        
//         return sqlInjectionKeywords.some(keyword => value.toUpperCase().includes(keyword))
//     } catch (error) {
//         await LogErrors('ValidateSqlInjection BL Security', error)
//     }
// }

/**
 * Detecta intentos de Inyección SQL en una cadena de texto en el frontend.
 * @param {string} value - El texto a validar.
 * @returns {Promise<boolean>} - True si se detecta una amenaza, False si es seguro.
 */
const ValidateSqlInjection = async (value) => {
    try {
        if (!value) return false;

        const upperValue = value.toUpperCase();

        // 1. Palabras clave compuestas (Bien adaptado, evita falsos positivos en palabras normales)
        const sqlKeywords = [
            'DROP TABLE', 'DELETE FROM', 'INSERT INTO', 'TRUNCATE TABLE', 
            'ALTER TABLE', 'EXEC(', 'EXECUTE(', 'UNION ALL', 'UNION SELECT'
        ];

        // Se usa un regex para UPDATE seguido de un espacio para evitar bloquear palabras como "UPDATED"
        const hasUpdateKeyword = /\bUPDATE\s+/i.test(value);
        const hasKeyword = sqlKeywords.some(keyword => upperValue.includes(keyword)) || hasUpdateKeyword;

        // 2. Patrones de inyección en lugar de caracteres sueltos
        // En vez de bloquear un ";" o "--" aislados, bloqueamos patrones clásicos de inyección:
        // - Punto y coma seguido de una palabra reservada SQL (ej. "; DROP")
        // - Comillas seguidas de OR o AND lógico (ej. "' OR '1'='1")
        // - Comillas seguidas de guiones dobles (ej. "' --")
        const maliciousPatterns = [
            /;\s*(DROP|DELETE|INSERT|UPDATE|TRUNCATE|ALTER|EXEC)/i, 
            /['"]\s*(OR|AND)\s*['"]?\d+['"]?\s*=\s*['"]?\d+/i,        
            /['"]\s*--/i                                              
        ];

        const hasMaliciousPattern = maliciousPatterns.some(regex => regex.test(value));

        // 3. Patrón común de ataque booleano sin comillas (ej: "OR 1=1")
        const hasBooleanAttack = /\bOR\s+\d+=\d+/i.test(value);

        return hasKeyword || hasMaliciousPattern || hasBooleanAttack;

    } catch (error) {
        // Mantenemos tu logueo de errores original
        await LogErrors('ValidateSqlInjection BL Security', error);
        return true; // Fail Safe: ante la duda, bloqueamos.
    }
};

/**
 * Valida la seguridad de una contraseña según múltiples criterios.
 * 
 * @param {string} password - La contraseña a validar.
 * @returns {string|null} - Mensaje de error si hay una falla, o `null` si es válida.
 */
const ValidatePassword = async (password) => {
    try {
        if (!password) {
            return 'La contraseña es obligatoria'
        }
    
        if (password.length < 8) {
            return 'La contraseña debe tener al menos 8 caracteres'
        }
    
        if (!/[A-Z]/.test(password)) {
            return 'La contraseña debe contener al menos una letra mayúscula'
        }
    
        if (!/[a-z]/.test(password)) {
            return 'La contraseña debe contener al menos una letra minúscula'
        }
    
        if (!/[0-9]/.test(password)) {
            return 'La contraseña debe contener al menos un número'
        }
    
        if (!/[!@#$%^&*()\-=+[\]{}|:'",.<>?/`~]/.test(password)) {
            return 'La contraseña debe contener al menos un carácter especial (!@#$%^&*()-_=+[]{}|:\'",.<>?/`~)'
        }

        if (await ValidateSqlInjection(password)) {
            return 'La contraseña contiene patrones inválidos'
        }
    
        return null // Indica que la contraseña es válida
    } catch (error) {
        await LogErrors('ValidatePassword BL Security', error)
    }
}





/** Bloquea F12 y Ctrl+Shift+I */
const BlockDevTools = () => {
    try {
        const handleKey = (e) => {
            if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i'))) {
                e.preventDefault()
            }
        }
        window.addEventListener('keydown', handleKey)
        listeners.push(() => window.removeEventListener('keydown', handleKey))      
    } catch (error) {
        LogErrors('BlockDevTools - BL Security', error)
    }
}

/** Bloquea seleccion de texto, copiar y cortar */
const BlockTextSelection = () => {
    try {
        const disableSelect = (e) => e.preventDefault()
        document.addEventListener('selectstart', disableSelect)
        document.addEventListener('copy', disableSelect)
        document.addEventListener('cut', disableSelect)
        listeners.push(() => (
            document.removeEventListener('selectstart', disableSelect),
            document.removeEventListener('copy', disableSelect),
            document.removeEventListener('cut', disableSelect)
        ))
    } catch (error) {
        LogErrors('BlockTextSelection - BL Security', error)      
    }
}

/** Bloquea imprimir pantalla (no confiable pero puede disuadir) */
const BlockPrintScreen = (callback) => {
    try {
        const handleKey = (e) => {
          if (e.key === 'PrintScreen') {
            e.preventDefault()
            e.stopPropagation()
            callback?.()
          }
        }
        window.addEventListener('keydown', handleKey)
        listeners.push(() => window.removeEventListener('keydown', handleKey))      
    } catch (error) {
        LogErrors('BlockPrintScreen - BL Security', error)
    }
}

/**
 * Bloquear menú contextual
 */
const BlockContextMenu = () => {
    try {
        const handleContextMenu = (e) => e.preventDefault()
        document.addEventListener('contextmenu', handleContextMenu)
        listeners.push(() => document.removeEventListener('contextmenu', handleContextMenu))
    } catch (error) {
        LogErrors('BlockContextMenu - BL Security', error)
    }
}

/**
 * Bloquea todos los eventos para un examen (botones, eventos, etc)
 */
const EnableAllRestrictions = ({ onScreenshot } = {}) => {
    try {
        BlockDevTools()
        BlockTextSelection()
        BlockPrintScreen(onScreenshot)    
        BlockContextMenu()
    } catch (error) {
        LogErrors('EnableAllRestrictions - BL Security', error)
    }
}

/**
 * Quita todas las restricciones de botones y eventos
 */
const DisableAllRestrictions = () => {
    try {
        if (listeners.length > 0) {
            listeners.forEach((remove) => remove())
            listeners = []
        }
    } catch (error) {
        LogErrors('DisableAllRestrictions - BL Security', error)
    }
}

export { ValidateSqlInjection, ValidatePassword, EnableAllRestrictions, DisableAllRestrictions };